module.exports = __webpack_public_path__ + "img/code_edit_visiteur.f52e4037.png";